import type {DaoMedia} from "../../daos/dao-media.ts";
import {useEffect, useState} from "react";
import {Utils} from "../../modules/utils.ts";
import * as React from "react";
import _ from "lodash";
import {askConfirm} from "../../stores/dialog.thunk.ts";
import {useAppDispatch} from "../../stores/hook.ts";
import {onair} from "../../modules/config.ts";
import {OnairEvent} from "../../modules/onair.ts";

interface AiVoiceProps {
  aivoice: DaoMedia,
  callbackListen?: (announce: DaoMedia) => void;
  callbackCopy?: (announce: DaoMedia) => void;
  callbackDelete?: (announce: DaoMedia) => void;
}

export function AiVoice({aivoice, callbackListen, callbackCopy, callbackDelete}: AiVoiceProps) {
  const [daoAnnounce] = useState<DaoMedia>(aivoice);
  const [position, setPosition] = useState(0);
  const dispatch = useAppDispatch();

  useEffect(() => {
    onair.on(OnairEvent.MEDIA, onMediaChangeHandler);

    if(daoAnnounce && onair.media && _.isEqual(String(daoAnnounce.type), String(onair.media.type)) && _.isEqual(String(daoAnnounce.media), String(onair.media.media))) {
      onair.on(OnairEvent.DURATION, onMediaDurationChangeHandler);
    }

    return () => {
      onair.off(OnairEvent.MEDIA, onMediaChangeHandler);
      onair.off(OnairEvent.DURATION, onMediaDurationChangeHandler);
    };
  }, []);

  function onMediaChangeHandler(_media: unknown) {
    const media: DaoMedia = _media as DaoMedia;
    if(media) {
      setPosition(0);
      if(daoAnnounce && _.isEqual(String(daoAnnounce.type), String(media.type)) && _.isEqual(String(daoAnnounce.media), String(media.media))) {
        onair.on(OnairEvent.DURATION, onMediaDurationChangeHandler);
      } else {
        onair.off(OnairEvent.DURATION, onMediaDurationChangeHandler);
      }
    }
  }

  function onMediaDurationChangeHandler(_currentTime: unknown) {
    setPosition(_currentTime as number);
  }

  async function listenHandler(e: React.MouseEvent | React.TouchEvent) {
    e.stopPropagation();

    setPosition(0);

    if(_.isFunction(callbackListen)) {
      const isConfirmed = await dispatch(askConfirm('', `"${getShortTitle()}" Ai음성을 재생하시겠습니까?`));
      if (isConfirmed) {
        callbackListen.call(null, daoAnnounce);
      }
    }
  }

  function getShortTitle(): string {
    return Utils.strLength(daoAnnounce.title) > 15 ? `${Utils.strCut(daoAnnounce.title, 15)}...` : daoAnnounce.title;
  }

  /**
   * 내용 복사 콜백
   */
  function copyHandler() {
    if(_.isFunction(callbackCopy)) {
      callbackCopy.call(null, daoAnnounce);
    }
  }

  /**
   * 내용 복사 콜백
   */
  async function deleteHandler() {
    if(_.isFunction(callbackDelete)) {
      const isConfirmed = await dispatch(askConfirm('', `"${getShortTitle()}" Ai음성을 삭제하시겠습니까?`));
      if (isConfirmed) {
        callbackDelete.call(null, daoAnnounce);
      }
    }
  }

  return (
    <article className="ai-item">
      <div className="time">{daoAnnounce.start_base}
        <div className="icon-wrap">
          <span><a onClick={copyHandler}><img src="/images/icon-copy.png" alt="" /></a></span>
          <span><a onClick={deleteHandler} className={`${daoAnnounce.is_favorite ? 'disable' : ''}`}><img src="/images/icon-del2.png" alt="" /></a></span>
        </div>
      </div>
      <div className="desc">{daoAnnounce.title}
      </div>
      <div className="audio-bar">
        <div className="audio-bar-fill" style={{ width: `${Math.max(Math.min((((position ?? 0) / (daoAnnounce?.duration ?? 0)) * 100), 100), 0)}%` }}></div>
        <span className="duration">{Utils.duration(daoAnnounce.duration)}</span>
        <button className="play-button" aria-label="재생" onClick={listenHandler}><img src="/images/icon-play.png" alt="" /></button>
      </div>
    </article>
  );
}